import React from 'react';

import { CommonCellRendererWrapper } from './styled';
import { TOTAL_BILLABLE_HEADER_DISPLAY_NAME } from '@components/usage-dashboard/constant';

export const CommonCellRenderer = ({ cellData, rowData }) => {
  const text = cellData || '-';
  const isTotalRow = rowData?.customerName === TOTAL_BILLABLE_HEADER_DISPLAY_NAME;

  return (
    <CommonCellRendererWrapper
      tooltipText={text}
      style={{ fontWeight: isTotalRow ? 600 : 'normal' }}
    >
      {text}
    </CommonCellRendererWrapper>
  );
};
